import { render, staticRenderFns } from "./Robot.vue?vue&type=template&id=0cc4073a&scoped=true&"
var script = {}
import style0 from "./Robot.vue?vue&type=style&index=0&id=0cc4073a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cc4073a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/hanzhu/nutstore-webpages/js_src_vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0cc4073a')) {
      api.createRecord('0cc4073a', component.options)
    } else {
      api.reload('0cc4073a', component.options)
    }
    module.hot.accept("./Robot.vue?vue&type=template&id=0cc4073a&scoped=true&", function () {
      api.rerender('0cc4073a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/page_eagle_landing/components/FloatComponents/Robot.vue"
export default component.exports